import {
  COLOR_POPUP_BG_DEFAULT,
  COLOR_POPUP_TEXT_DEFAULT,
  CONFIG_THEME_COLOR_DEFAULT,
} from '@containers/Home/constants';
import { TypeThemeConfig } from '@containers/Home/types';
import { createGlobalStyle } from 'styled-components';

type ThemeSelected = Exclude<TypeThemeConfig, null | undefined>['selected'];

const resolveThemeColors = (selected: ThemeSelected) =>
  selected === 'default' || selected === 'defaultNew' || selected === 'custom1'
    ? CONFIG_THEME_COLOR_DEFAULT[selected]
    : CONFIG_THEME_COLOR_DEFAULT.default;

/* istanbul ignore next */
export const ThemeGlobal = createGlobalStyle<{
  selected: ThemeSelected;
  primaryColor?: string;
  secondaryColor?: string;
  textColor?: string;
  popupBgColor?: string;
  popupTextColor?: string;
}>`
  :root {
    --color-primary: ${props =>
      props.primaryColor || resolveThemeColors(props.selected)?.primaryColor};
    --color-primary--light: ${props =>
      props.primaryColor || resolveThemeColors(props.selected)?.primaryColor}80;
    --color-secondary: ${props =>
      props.secondaryColor ||
      CONFIG_THEME_COLOR_DEFAULT.custom1?.secondaryColor};
    --color-text: ${props =>
      props.textColor || resolveThemeColors(props.selected)?.textColor};
    --color-popup-bg: ${props => props.popupBgColor || COLOR_POPUP_BG_DEFAULT};
    --color-popup-text: ${props =>
      props.popupTextColor || COLOR_POPUP_TEXT_DEFAULT};
    --color-icon: #fff;
  }

`;
